var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headings--h2"},[_vm._v("\n  "+_vm._s(_vm.catalogNumber)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c47157b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/artwork_catalog_number.vue
// module id = 335
// module chunks = 0 1 2 3 4 5 6 7 8 10 15 18 19 30 32 40 44 70 86 87 91 92 360